export const copyToClipboard = (text: string, onSuccess?: () => void, onError?: () => void) => {
	navigator.clipboard.writeText(text).then(
		() => {
			console.log('Text copied to clipboard');
			onSuccess && onSuccess();
		},
		err => {
			console.error('Could not copy text: ', err);
			onError && onError();
		},
	);
};
